// @ts-nocheck
/* eslint-disable */
const {
  ORG_VIEW,
  AGENCY_VIEW,
  APP_VIEW,
  ORG_VIEW_ID_FIELD,
  APP_VIEW_ID_FIELD,
} = require('../../common/support/viewConstants');

function isProduction(env) {
  return env !== 'development';
}

export function getDashboardResourceRouteForMicroFrontend({ env, origin, nonSSODashboardUrl }) {
  if (isProduction(env)) {
    return nonSSODashboardUrl;
  }
  return origin;
}

export class MicroFrontendContextPayloadProvider {
  constructor(options) {
    this.origin = options.origin;
    this.view = options.view;
    this.env = options.env;
    this.pendo = options.pendo;
    this.sentry = options.sentry;
    this.nonSSODashboardUrl = options.nonSSODashboardUrl;
    this.codeVersion = options.codeVersion;
    this.userId = options.userId;
    this.vidaliaEnabled = options.vidaliaEnabled;
  }

  getPayloadOrigin() {
    return {
      origin: getDashboardResourceRouteForMicroFrontend({
        origin: this.origin,
        env: this.env,
        nonSSODashboardUrl: this.nonSSODashboardUrl,
      }),
    };
  }

  getPayloadEntity() {
    switch (this.view.current_view) {
      case ORG_VIEW:
      case AGENCY_VIEW:
        return {
          'organization-id': this.view[ORG_VIEW_ID_FIELD],
        };
      case APP_VIEW:
      default:
        return {
          'app-id': this.view[APP_VIEW_ID_FIELD],
        };
    }
  }

  getPayload() {
    return {
      ...this.getPayloadOrigin(),
      ...this.getPayloadEntity(),
      system: {
        env: 'prod',
        cdnPath: '/micro-frontends/master/qlt/latest',
      },
      env: this.env,
      pendo: this.pendo,
      sentry: this.sentry,
      pathname: window.location.pathname,
      nonSSODashboardUrl: this.nonSSODashboardUrl,
      codeVersion: this.codeVersion,
      userId: this.userId,
      vidaliaEnabled: this.vidaliaEnabled,
    };
  }
}
